module.exports = __webpack_public_path__ + "media/images/lb/713-13b6a6c18108075f9f200eb3c5306f9e.svg";